// T362 — one definition of "treat this string as literal text".
//
// SIX private copies of this function already existed — worker ingestion
// dedup.js and html.js, shared roles.js, skills.js and company.js, and
// normalize.js twice — all with identical bodies and three of them not even
// named. A scout that went looking found five; the sixth turned up only when
// the grep was widened, which is the argument for this file in one line. They were all safe
// because they escape data the app produced. Mail search is the first place
// the string comes from a person typing into a box, which is exactly where a
// sixth copy would be the wrong move.
//
// Why it matters here even though nobody can attack anybody: the route is
// behind auth and scoped to one user's own mail, so an unescaped pattern is not
// a security hole. It is a correctness hole. His corpus is full of `C++`,
// `(m/f/d)`, `[Remote]` and `salary?` — ordinary strings a person would paste
// into a search box — and unescaped they either throw or quietly match the
// wrong thing. Worse, Mongo's PCRE2 backtracking cap makes a pathological
// pattern return NO match rather than an error, so the failure arrives looking
// like a real empty result.

/** Escape every regex metacharacter, so the string matches itself and nothing else. */
export function escapeRegex(input) {
  return String(input ?? '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
